import 'isomorphic-fetch';
export function fetch(input, options) {
  const fetchOptions = {
    ...options
  };
  const defaultHeaders = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  };
  let request;
  fetchOptions.credentials = fetchOptions.credentials || 'same-origin';
  fetchOptions.headers = {
    ...defaultHeaders,
    ...fetchOptions.headers
  };
  request = global.fetch(input, fetchOptions);
  return request.then(response => {
    if (!response.ok) {
      return Promise.reject(response);
    }
    return response;
  });
}